import { useState, useEffect } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import TransactionTombstone from './Transactions/TransactionTombstone';
import { device } from '../../../utils/styled-component-mixins';

const TransactionCardDivStyled = styled.div`
  @media ${device.desktop} {
    .hover-in {
      .overflow-wrapper {
        right: 0;
      }
    }

    .hover-out {
      .overflow-wrapper {
        right: 7rem;
      }
    }
  }

  .transaction-item-container {
    background-color: black;
    box-shadow: var(--card-shadow);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    position: relative;
    padding: 2rem 2rem;
    width: 100%;
  }

  .transaction-section-container {
    gap: 3rem;
    margin-top: 10rem;
    padding-bottom: 10rem;
    justify-content: center;
    align-items: center;

    &.preload * {
      animation: none !important;
      transition: none !important;
    }
  }

  .transaction-quote {
    font-size: 1.2rem;
    line-height: 2rem;
    margin: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
    word-break: break-word;
    text-align: center;
  }

  .animation-wrapper {
    overflow: hidden;
    margin-top: auto;
    margin-bottom: 2rem;
  }

  .overflow-wrapper {
    position: relative;
    transition: all 0.3s ease-in-out !important;
  }

  .overflow-wrapper > .cta-wrapper {
    align-items: center;
    color: var(--cta-blue);
    display: flex;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.8rem;
    margin-top: 1.8rem;
    text-decoration: none;

    span:last-child {
      font-size: 3.2rem;
    }
    @media ${device.tablet} {
      transition: all 0.3s ease-in-out;

      span:first-child {
        transition: all 0.3s ease-in-out;
      }
    }
  }
`;

const TransactionCard = (props) => {
  const { transaction } = props;
  const [hoverState, setHoverState] = useState(null);

  useEffect(() => {
    setHoverState('hover-out');
  }, []);

  return (
    <TransactionCardDivStyled
      className="transaction-item"
      onMouseEnter={() => setHoverState('hover-in')}
      onMouseLeave={() => setHoverState('hover-out')}
    >
      {transaction.transactionTombstoneImage1Path !== '' && (
        <TransactionTombstone
          src={transaction.transactionTombstoneImage1Path}
          alt={transaction.transactionTombstoneAltText1}
          loading="lazy"
        />
      )}
      {transaction.transactionTombstoneDescription1 !== '' && (
        <p className="transaction-quote">{transaction.transactionTombstoneDescription1}</p>
      )}
      {transaction.transactionTombstoneImage2Path !== '' && (
        <TransactionTombstone
          src={transaction.transactionTombstoneImage2Path}
          alt={transaction.transactionTombstoneAltText2}
          loading="lazy"
        />
      )}
      {transaction.transactionTombstoneDescription2 !== '' && (
        <p className="transaction-quote">{transaction.transactionTombstoneDescription2}</p>
      )}
      {transaction.transactionTombstoneImage3Path !== '' && (
        <TransactionTombstone
          src={transaction.transactionTombstoneImage3Path}
          alt={transaction.transactionTombstoneAltText3}
          loading="lazy"
        />
      )}
      {transaction.transactionTombstoneDescription3 !== '' && (
        <p className="transaction-quote">{transaction.transactionTombstoneDescription3}</p>
      )}
      {transaction.transactionTombstoneImage4Path !== '' && (
        <TransactionTombstone
          src={transaction.transactionTombstoneImage4Path}
          alt={transaction.transactionTombstoneAltText4}
          loading="lazy"
        />
      )}
      {transaction.transactionTombstoneDescription4 !== '' && (
        <p className="transaction-quote">{transaction.transactionTombstoneDescription4}</p>
      )}
      <div className={classNames('animation-wrapper', hoverState)}>
        <div className="overflow-wrapper">
          <div className="cta-wrapper">
            <span>Read More</span>
            <span className="material-icons-round" aria-hidden="true">
              chevron_right
            </span>
          </div>
        </div>
      </div>
    </TransactionCardDivStyled>
  );
};

export default TransactionCard;
